import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { AuthLayoutComponent } from "./auth-layout/auth-layout.component";
import { AuthGuard } from "./shared/guard/auth.guard";
import { AccessDeniedComponent } from "./shared/components/access-denied/access-denied.component";
import { VendorGuard } from "./shared/guard/vendor.guard";
import { NotificationRedirectComponent } from "./pages/notification-redirect/notification-redirect.component";

const routes: Routes = [
  {
    path: "",
    redirectTo: "home",
    pathMatch: "full",
  },
  {
    // Protected feature routes
    path: "",
    canActivateChild: [AuthGuard],
    children: [
      {
        path: "",
        loadChildren: () =>
          import("./pages/kepler/kepler.module").then((m) => m.KeplerModule),
      },
      {
        path: "delivery",
        data: { breadcrumb: "Delivery Lens" },
        loadChildren: () =>
          import("./pages/delivery/delivery.module").then(
            (m) => m.DeliveryModule
          ),
      },
      {
        path: "view",
        data: { breadcrumb: "Delivery Lens" },
        loadChildren: () =>
          import("./pages/delivery-functionality/delivery-functionality.module").then(
            (m) => m.DeliveryFunctionalityModule
          ),
      },
      {
        path: "actiontracker",
        data: { breadcrumb: "Prism" },
        loadChildren: () =>
          import("./pages/action-tracker/action-tracker.module").then(
            (m) => m.ActionTrackerModule
          ),
        canActivate: [VendorGuard],
      },
      {
        path: "toemasterlist",
        data: { breadcrumb: "Prism" },
        loadChildren: () =>
          import("./pages/key-terms/key-terms.module").then(
            (m) => m.KeyTermsModule
          ),
        canActivate: [VendorGuard],
      },
      {
        path: "metrics-master",
        data: { breadcrumb: "Metrics Master" },
        loadChildren: () =>
          import("./pages/metrics-master/metrics-master.module").then(
            (m) => m.MetrcisMasterModule
          ),
        canActivate: [VendorGuard],
      },
      {
        path: "incidentracker",
        data: { breadcrumb: "GRC Workbench" },
        loadChildren: () =>
          import("./pages/incident-tracker/incident-tracker.module").then(
            (m) => m.IncidentTrackerModule
          ),
        canActivate: [VendorGuard],
      },
      {
        path: "balancedscorecard",
        data: { breadcrumb: "Kaleidoscope", clickable: false },
        loadChildren: () =>
          import("./pages/balancescore/balancescore.module").then(
            (m) => m.BalancescoreModule
          ),
      },
      {
        path: "bvt-index",
        loadChildren: () =>
          import("./pages/bvt-index/bvt-index.module").then(
            (m) => m.BvtIndexModule
          ),
        canActivate: [VendorGuard],
      },
      {
        path: "riskconvergence",
        loadChildren: () =>
          import("./pages/risk-convergence/risk-convergence.module").then(
            (m) => m.RiskConvergenceModule
          ),
      },
      {
        path: "parade",
        data: { breadcrumb: "Confluence", clickable: false },
        loadChildren: () =>
          import("./pages/parade/parade.module").then((m) => m.ParadeModule),
      },
      {
        path: "okrconvergence",
        loadChildren: () =>
          import("./pages/okr-convergence/okr-convergence.module").then(
            (m) => m.OkrConvergenceModule
          ),
        canActivate: [VendorGuard],
      },
      {
        path: "vendor-master",
        data: { breadcrumb: "Vendor Master" },
        loadChildren: () =>
          import("./pages/vendor-master/vendor-master.module").then(
            (m) => m.VendorMasterModule
          ),
        canActivate: [VendorGuard],
      },
      {
        path: "application-master",
        data: { breadcrumb: "Application Master" },
        loadChildren: () =>
          import("./pages/application-master/application-master.module").then(
            (m) => m.ApplicationMasterModule
          ),
        canActivate: [VendorGuard],
      },
      {
        path: "rate",
        loadChildren: () =>
          import("./pages/rate/rate.module").then((m) => m.RateModule),
      },
      {
        path: "workforce",
        data: { breadcrumb: "Workforce Catalog" },
        loadChildren: () =>
          import("./pages/work-force/work-force.module").then(
            (m) => m.WorkFlowModule
          ),
        canActivate: [VendorGuard],
      },
      {
        path: "metrics-builder",
        loadChildren: () =>
          import("./pages/formula-builder/formula-builder.module").then(
            (m) => m.FormulaBuilderModule
          ),
      },

      {
        path: "access-denied",
        component: AccessDeniedComponent,
      },
      {
        path: "qzt7vb4mdx9klpr2wgnc",
        component: NotificationRedirectComponent,
      },
    ],
  },
  {
    // Auth routes (login, SSO, etc.) — same flow as Kepler
    path: "auth",
    component: AuthLayoutComponent,
    children: [
      {
        path: "",
        loadChildren: () =>
          import("./pages/auth/auth.module").then((m) => m.AuthModule),
      },
    ],
  },
  {
    path: "home",
    component: AuthLayoutComponent,
    children: [
      {
        path: "",
        loadChildren: () =>
          import("./pages/auth/auth.module").then((m) => m.AuthModule),
      },
    ],
  },
  {
    path: "404",
    loadChildren: () =>
      import("./pages/pagenotfound/pagenotfound.module").then(
        (m) => m.PagenotfoundModule
      ),
  },
  {
    path: "**",
    redirectTo: "404",
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { onSameUrlNavigation: "reload" })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
